import { Alert, AlertTitle } from '@mui/lab';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

const useStyles = makeStyles(theme => ({
  errorHeader: {
    fontWeight: 600,
    color: ({ severity }) => theme.palette.alerts[severity].color,
    marginTop: 0,
    marginBottom: 0
  },
  alert: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: 0
    },
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 0
    }
  },
  expandIcon: {
    color: ({ severity }) => theme.palette.alerts[severity].color,

    [theme.breakpoints.down('sm')]: {
      marginRight: 0
    }
  },
  icon: {
    color: ({ severity }) => theme.palette.alerts[severity].iconColor,
    border: 'solid',
    borderRadius: '50%',
    height: '44px',
    width: '44px',
    display: 'flex',
    padding: '7px',
    justifyContent: 'center',
    background: ({ severity }) => theme.palette.alerts[severity].iconBackground,
    borderColor: 'transparent',

    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      marginBottom: 0
    }
  }
}));

const groupIconMapping = {
  error: <ErrorOutlineRoundedIcon />,
  info: <PersonOutlineOutlinedIcon />,
  warning: <EmojiObjectsOutlinedIcon />
};

const title = (t, countRows) => ({
  warning: t('feedback.warnings.warning', { count: countRows })
});

const Header = ({ severity, countRows }) => {
  const classes = useStyles({ severity });
  const { t } = useTranslation(['employee']);

  return (
    <Alert
      variant="filled"
      severity={severity}
      iconMapping={groupIconMapping}
      classes={{
        root: classes.alert,
        icon: classes.icon,
        message: classes.message
      }}
    >
      <AlertTitle className={classes.errorHeader}>{title(t, countRows)[severity]}</AlertTitle>
    </Alert>
  );
};

Header.propTypes = {
  severity: PropTypes.string,
  countRows: PropTypes.number
};

export default Header;
